// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"HQ-z","smallCardRow":"IQ-z","largeCardRow":"JQ-z","productSearchRow":"KQ-z","curatedRow":"LQ-z"};